import { SelectOptions } from '@src/typings'
import { gql } from 'graphql-tag'
import forEach from 'lodash/forEach'
import { i18n } from '../index'

export const ASSIGNMENTS_QUERY = gql`
  query Assignments(
    $stationId: ID!
    $status: AssignmentStatusEnum
    $fromDate: String
    $toDate: String
    $page: Int
    $perPage: Int
    $subject: AssignmentSubjectEnum
  ) {
    assignments(
      stationId: $stationId
      status: $status
      fromDate: $fromDate
      toDate: $toDate
      page: $page
      perPage: $perPage
      subject: $subject
    ) {
      total
      edges {
        node {
          __typename
          id
          subject
          description
          assignee {
            id
            name
          }
          assignees {
            id
            name
          }
          deadline
          status
          comment
          doneAt
        }
      }
    }
  }
`

type AssignmentSubjectEnum = 'Market' | 'Restaurant' | 'Kitchen' | 'Hesburger' | 'Management' | 'Other'
type AssignmentStatusEnum = 'Done' | 'InProgress'

export type Assignment = {
  id: string
  subject: AssignmentSubjectEnum
  description: string
  assignee: { id: string; name: string } // TODO: This needs to be a user relation.
  assignees: Array<{ id: string; name: string }>
  deadline: string
  status: AssignmentStatusEnum
  comment: string
  doneAt: string
}

const ASSIGNMENT_SUBJECT_LABELS = {
  Market: 'taskList.subjectLabel.Market',
  Restaurant: 'taskList.subjectLabel.Restaurant',
  Kitchen: 'taskList.subjectLabel.Kitchen',
  Hesburger: 'taskList.subjectLabel.Hesburger',
  Management: 'taskList.subjectLabel.Management',
  Other: 'taskList.subjectLabel.Other',
}

const ASSIGNMENT_STATUS_LABELS = {
  Done: 'taskList.assignmentTypeLabel.Done',
  InProgress: 'taskList.assignmentTypeLabel.InProgress',
}

export const getAssignmentSubjectOptions = () => {
  const options: SelectOptions[] = []

  forEach(ASSIGNMENT_SUBJECT_LABELS, (label, value) => {
    options.push({
      label: i18n.t(label),
      value,
    })
  })

  return options
}

export const getAssignmentSubjectLabel = (subject: string): string => {
  return i18n.t(`taskList.subjectLabel.${subject}`)
}
